import NewAbout from "../components/Sobre";

export default function Sobre() {

    return <NewAbout />
}